import SessionsSummary from './SessionsSummary';

export default SessionsSummary;
